import { render, staticRenderFns } from "./Bridge.vue?vue&type=template&id=f5bec214&"
import script from "./Bridge.vue?vue&type=script&lang=js&"
export * from "./Bridge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports